import { useLang } from 'hooks/lang';

import { calculateServiceCost, ProjectService } from 'entities';

import { Column, LabeledSelect, Row, Tag } from 'components/Blocks';
import { EntityStatusTag } from 'components/Entities';

import { formatCurrency } from 'utils/text';

interface ServiceSelectProps {
  selectedServices: string[];
  onServiceChange(ids: string[]): void;
  currency: string;
  services: Array<
    ProjectService & {
      taskName: string;
      taskId: string;
      taskStatus: string;
      label: string;
      disabled: boolean;
    }
  >;
}

export function ServiceSelect({
  selectedServices,
  currency,
  onServiceChange,
  services,
}: ServiceSelectProps) {
  const { t } = useLang();

  return (
    <LabeledSelect
      label={t('services')}
      disabledKey="disabled"
      options={services}
      isMulti
      hideSelectedOptions
      value={selectedServices}
      onChangeDirect={onServiceChange}
      className={selectedServices.length ? 'py-1' : ''}
      formatLabel={({ label, taskStatus, outsourceConfig, ...rest }) => (
        <Column gap="0">
          <Row gap="2">
            <span className="text-sm font-medium">{label}</span>

            <EntityStatusTag
              target="task"
              status={taskStatus}
              size="tiny"
              round={false}
              className="w-fit"
            />

            {outsourceConfig && (
              <Tag
                size="tiny"
                color="warning"
                name={t(outsourceConfig?.approved ? 'outsourced' : 'service-in-outsource-flow')}
              />
            )}
          </Row>

          <span className="text-xs">{formatCurrency(calculateServiceCost(rest), currency)}</span>
        </Column>
      )}
    />
  );
}
